/**
 * TikTok 手动「同步更新」配额 kind：每个按钮每天单独计次（店铺之间互不占用）。
 * 与后端 TiktokManualSyncPaths 的路径映射保持一致。
 */

export function toTiktokManualSyncQuotaKind(kind) {
  if (kind == null) return '';
  const s = String(kind).trim();
  if (!s) return '';
  return s
    .replace(/[_\s/]+/g, '-')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
}

export function resolveTiktokManualSyncQuotaKindFromPath(path) {
  const p = String(path || '').split('?')[0];
  const m = p.match(/\/shops\/\d+\/(.+)$/);
  if (!m) return '';
  return buttonKeyForRest(m[1]);
}

function buttonKeyForRest(rest) {
  const r = String(rest || '');
  if (r.startsWith('products/')) return 'product';
  if (r.startsWith('shop-profile/')) return 'shop-profile';
  if (r.startsWith('aftersales/orders/')) return 'orders';
  if (r.startsWith('aftersales/returns/')) return 'return-orders';
  if (r.startsWith('certificate-library/')) return 'certificate-library';
  if (r.startsWith('certificates/')) return 'certificate';
  if (r.startsWith('finance/')) return 'finance';
  if (r.startsWith('compliance/agencies/')) return 'agency';
  if (r.startsWith('compliance/environmental-materials/')) return 'environmental';
  if (r.startsWith('compliance/skc-agency/')) return 'skc-agency';
  if (r.startsWith('compliance/')) return 'compliance';
  if (r.startsWith('discuss/')) return 'discuss';
  if (r.startsWith('rrp/audit/')) return 'rrp-audit';
  if (r.startsWith('rrp/')) return 'rrp-skc';
  if (r.startsWith('publish-records/')) return 'publish-record';
  return r.replace(/\/sync-jobs$/, '').replace(/\/sync$/, '').replace(/\//g, '-') || 'sync';
}
